import { FC, memo } from 'react';
import { Box } from '@mui/material';
import { Grid as KendoGrid, GridCellProps, GridColumn, GridDetailRowProps } from '@progress/kendo-react-grid';
import NumberCell from 'src/components/grid/NumberCell';
import { ItemActivity } from 'src/types/itemActivity';
import DateCell from 'src/components/grid/DateCell';

const ItemDetailActivity: FC<React.PropsWithChildren<GridDetailRowProps>> = ({ dataItem }) => {
  const activity: ItemActivity[] = dataItem.activity;
  const dateCell = (cellProps: GridCellProps) => <DateCell {...cellProps} dateOnly={true} />;

  return (
    <Box>
      <KendoGrid data={activity} sortable resizable={true} reorderable={true} scrollable="scrollable" dataItemKey="id" style={{ width: '100%', minHeight: '100px' }}>
        <GridColumn field="dueDate" title="Due Date" cells={{ data: dateCell }} width={100} />
        <GridColumn field="type" title="Type" width={120} />
        <GridColumn field="docNumber" title="Doc #" width={100} />
        <GridColumn field="sourceOrDestination" title="Vendor/Whse" width={200} />
        <GridColumn field="quantityOrdered" format="0" cells={{ data: NumberCell }} title="Quantity (Change)" width={150} />
        <GridColumn field="runningTotalOnHand" format="0" cells={{ data: NumberCell }} title="Quantity (Balance)" width={150} />
        <GridColumn field="" title="" editable={false} />
      </KendoGrid>
    </Box>
  );
};

export default memo(ItemDetailActivity);
